var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{class:{ color_bg: _vm.status }}),_c('AppBar'),_c('Drawer'),_c('ResetPasswordDialog'),_c('v-main',{staticStyle:{"z-index":"2","position":"relative","height":"100vh"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('SnackBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }